import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    flexikontoPaymentPause: {
      default: '/service-hilfe/service/bezahlung-und-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('FGkXan'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '2228',
      trafficMediumNumber: { default: '2', mobile: '18', app: '34' },
    },
  },
};
